import { render, staticRenderFns } from "./RegisterDataKontak.vue?vue&type=template&id=1e26f7ba&scoped=true&"
import script from "./RegisterDataKontak.vue?vue&type=script&lang=js&"
export * from "./RegisterDataKontak.vue?vue&type=script&lang=js&"
import style0 from "./RegisterDataKontak.vue?vue&type=style&index=0&id=1e26f7ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e26f7ba",
  null
  
)

export default component.exports